

























































































































import IWarehouse from '@/store/models/IWarehouse';
import IStock from '@/store/models/IStock';
import { Vue, Component, Watch } from 'vue-property-decorator';
import WarehouseApi from '../store/api/WarehouseApi';
import StockSelector from '@/components/selectors/Stock/StockSelector.vue';
import Snackbar from '@/components/shared/Snackbar.vue';
import IAuthentication from '@/store/models/IAuthentication';
import IRolePermission from '@/store/models/IRolePermission';
import StockApi from '../store/api/StockApi';
import PrintingApi from '@/store/api/PrintingApi';
import { SettingsCompany } from '@/components/shared/SettingsCompany';
import SettingsCompanyApi from '@/store/api/SettingsCompanyApi';
import ISettingsCompany from '@/store/models/ISettingsCompany';
import UploadServiceApi from '../store/api/UploadServiceApi';
import IListPalletType from '@/store/models/IListPalletType';
import ListPalletTypesApi from '@/store/api/ListPalletTypesApi';
import CustomerApi from '@/store/api/CustomerApi';
import ICustomer from '@/store/models/ICustomer';
import QRCode from "qrcode";
import ICompaniesLicence from '@/store/models/ICompaniesLicence';
import CompanyLicensesApi from '@/store/api/CompaniesLicensesApi';
import JSPDF from 'jspdf';
import HTML2CANVAS from 'html2canvas';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from 'moment';
import { EMPTY_GUID } from '@/config/constants';
@Component({
    components: {
        StockSelector,
        Snackbar
    }
})
export default class Stock extends Vue {
    // CompanySelector
    WarehouseList : IWarehouse[] = [];
    warehouseApi : WarehouseApi;
    printingApi : PrintingApi;
    selectedWarehouse : IWarehouse = {} as IWarehouse;
    permissions : IRolePermission[] = [];
    idCompany: string = "";
    StockList : IStock[] = [];
    StockListNoModifications : IStock[] = [];
    stockApi : StockApi;
    uploadServiceApi: UploadServiceApi;
    settingsCompanyApi: SettingsCompanyApi;
    warehouseIds : string[] = [];
    overlay: boolean = false;
    palletTypesList : IListPalletType[] = [];
    listPalletTypesApi : ListPalletTypesApi;
    isShared : boolean = false;
    showCustomer: boolean = false;
    showCustomerInLabel: boolean = true;
    customersApi : CustomerApi;
    CustomerList : ICustomer[] = [];
    contentToPrint: HTMLElement | null = null;
    contentToPrintForScanner: HTMLElement | null = null;
    currentItem: IStock = {} as IStock;
    showTemplate: boolean = true;
    showStockCustom: boolean = false;
    companyLicensesApi: CompanyLicensesApi;
    scannerActive: boolean = false;
    qrCodeData: string = "";
    constructor() {
        super();
        this.warehouseApi = new WarehouseApi();
        this.stockApi = new StockApi();
        this.printingApi = new PrintingApi("Stock");
        this.uploadServiceApi = new UploadServiceApi("Stock");
        this.settingsCompanyApi = new SettingsCompanyApi("Stock");
        this.listPalletTypesApi = new ListPalletTypesApi();
        this.customersApi = new CustomerApi();
        this.companyLicensesApi = new CompanyLicensesApi();
    }

    created() {
        this.getPermissions();
        this.getWarehouses();
        this.getPalletTypes();
        this.getCustomers();
        this.showTemplate = false;
    }

    mounted() {
        // Asignar la referencia después de que el componente está montado
        this.contentToPrint = this.$refs.contentToPrint as HTMLElement;
        this.contentToPrintForScanner = this.$refs.contentToPrintForScanner as HTMLElement;
    }

    async generatePalletQr(idPallet: string) {
        if (!idPallet) {
            this.qrCodeData = "";
            return;
        }
        this.qrCodeData = await QRCode.toDataURL(idPallet, { width: 120, margin: 1 });
    }

    async getCustomers() {
        this.CustomerList = await this.customersApi.GetCustomersByCompanyId(this.idCompany);
    }

    get isSuperAdmin() {
        return this.idCompany === EMPTY_GUID;
    }

    async getPalletTypes() {
        this.palletTypesList = await this.listPalletTypesApi.GetListPalleTypes();
    }

    async onChangeWarehouse(warehouses: IWarehouse[]) {
        this.isShared = false;
        if (warehouses.length > 0) {
            this.StockList = [];
            this.StockListNoModifications = [];
            this.warehouseIds = [];
            this.warehouseIds = warehouses.map(w => w.id);
            await this.getWarehouseStock(this.warehouseIds);
            for (let id of this.warehouseIds) {
                let warehouses = await this.warehouseApi.IsWarehouseShared(this.idCompany, id);
                if (warehouses.length > 0) {
                    this.isShared = true;
                    return;
                }
            }
        }
    }

    async saveLocationStock(item: IStock) {
        this.overlay = true;
        const success = await this.stockApi.UpdateStockLocation(item);
        this.overlay = false;
        if (!success) {
            this.showMessageError("Error saving stock location");
        }
    }

    async saveLocationsStock(items: IStock[]) {
        await Promise.all(items.map(i => this.saveLocationStock(i)));
        this.StockListNoModifications = JSON.parse(JSON.stringify(this.StockList));
        this.showMessageInfo(`The stock location has been successfully saved`);
    }

    resetLocationValue(item: IStock) {
        let index = this.StockList.findIndex(l => l.idPallet === item.idPallet);
        if (index > -1) {
            this.StockList[index].location = "";
        }
    }

    async savePalletTypeStock(item: IStock) {
        this.overlay = true;
        const success = await this.stockApi.UpdateStockPalletType(item);
        this.overlay = false;
        if (!success) {
            this.showMessageError("Error saving pallet type");
        } else {
            this.showMessageInfo(`The pallet type has been successfully saved`);
        }
    }

    async savePalletTypesStock(items: IStock[]) {
        await Promise.all(items.map(i => this.savePalletTypeStock(i)));
        this.showMessageInfo(`The pallet type has been successfully saved`);
    }

    async getWarehouseStock(warehouseIds: string[]) {
        this.overlay = true;
        this.StockList = await this.stockApi.GetStockGroupByWarehousesId(warehouseIds, this.idCompany, this.scannerActive);
        this.StockListNoModifications = JSON.parse(JSON.stringify(this.StockList));
        
        const companyWarehouseIds = this.WarehouseList.filter(w => w.idCompany === this.idCompany).map(w => w.id);
    
        this.StockList = this.StockList.filter((i) =>
            i.idCompanyDestination === this.idCompany ||
            i.idCompanySource === this.idCompany ||
            companyWarehouseIds.includes(i.idWarehouse)
        );
        if (this.StockList.length === 0) {
            this.showMessageWarning("The selected warehouse is out of stock.");
        } else {
            if (this.showCustomer === false) {
                this.StockList.forEach((i) => {
                    let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                    if (indexCustomer !== -1) {
                        if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                            i.customerName = "";
                        }
                    } else {
                        i.customerName = "";
                    }
                });
            }
        }
        this.overlay = false;
    }

    async getPermissions() {
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idCompany = userFromStorage.idCompany;
        this.permissions.push(userFromStorage.rolePermissions.find(r => r.formName === "Warehouses"));
        let setting : ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.ShowCustomer);
        if (setting.length > 0) {
            if (setting[0].value.toUpperCase() === "NO") {
                this.showCustomer = false;
            } else {
                this.showCustomer = true;
            }
        }
        setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.ShowStockCustom);
        if (setting.length > 0) {
            if (setting[0].value.toUpperCase() === "NO") {
                this.showStockCustom = false;
            } else {
                this.showStockCustom = true;
            }
        }
        let licencesForms: ICompaniesLicence[] = [];
        licencesForms = await this.companyLicensesApi.GetLicenceByIdCompany(this.idCompany);
        let hasLicenseScanner = licencesForms.some(license => license.formName.toLocaleLowerCase() === "scanner");
        if (!hasLicenseScanner) {
            this.scannerActive = true;
            setting = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, SettingsCompany.Settings.Scanner);
            if (setting.length > 0) {
                this.scannerActive = setting[0].value.toLocaleLowerCase() === "yes";
            }
        }
        setting = await this.settingsCompanyApi.getSettingCompanyId(
            this.idCompany,
            SettingsCompany.Settings.ShowCustomerInLabel
        );
        if (setting.length > 0) {
            this.showCustomerInLabel = setting[0].value.toUpperCase() !== "NO";
        } else {
            this.showCustomerInLabel = true;
        }
    }

    async getWarehouses() {
        this.WarehouseList = await this.warehouseApi.GetWarehousesShared(this.idCompany);
    }

    async updateQrValue() {
        const data = JSON.stringify({
            version: "3",
            id: this.currentItem!.id,
            idPallet: this.currentItem!.idPallet || '',
            idInbound: this.currentItem!.idInbound || '',
            idInboundDeliveryNoteDetail: this.currentItem!.idInboundDeliveryNoteDetail || '',
            type: "pallet"
        });
        this.qrCodeData = await QRCode.toDataURL(data, { width: 120, margin: 1 });
    }

    async printLabelsForScanner(items: IStock[]) {
        // Filtrar los pallets de stock que correspondan a las líneas seleccionadas
        const palletsToPrint: IStock[] = items;
        if (palletsToPrint.length === 0) {
            this.showMessageWarning("No pallets found for selected lines");
            return;
        }

        this.showTemplate = true;
        this.overlay = true;

        const doc = new JSPDF({
            format: "a6",
            unit: "mm",
            orientation: "portrait"
        });

        for (let index = 0; index < palletsToPrint.length; index++) {
            if (index > 0) doc.addPage();

            this.currentItem = palletsToPrint[index];
            await this.updateQrValue();
            await this.$nextTick();

            if (this.contentToPrintForScanner) {
                const canvas = await HTML2CANVAS(this.contentToPrintForScanner, {
                    backgroundColor: "#ffffff",
                    scale: 2,
                    useCORS: true
                });
                const imgData = canvas.toDataURL("image/png");
                const imgWidth = 98;
                const imgHeight = 148;
                doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
            }
        }

        doc.save("labels.pdf");

        this.overlay = false;
        this.showTemplate = false;
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    async printLabels(items: IStock[]) {
        if (this.isSuperAdmin === false) {
            if (items.length > 0) {
                this.showTemplate = true;
                this.overlay = true;
                let settingsCompany = SettingsCompany.Settings.IdStockLabelPrinting;
                let idRepport: ISettingsCompany[] = await this.settingsCompanyApi.getSettingCompanyId(this.idCompany, settingsCompany);
                
                if (idRepport) {
                    const doc = new JSPDF({
                        format: "a5",
                        unit: "mm",
                        orientation: "portrait"
                    });

                    for (let index = 0; index < items.length; index++) {
                        if (index > 0) {
                            doc.addPage();
                        }

                        // Asigna el item actual
                        this.currentItem = items[index];

                        // Busca el cliente asociado a este pallet
                        const customer = this.CustomerList.find(c => c.id === this.currentItem.idCustomer);

                        // ✅ Si el cliente tiene palletQr = true → genera el QR con el idPallet
                        if (customer && customer.palletQr === true && this.currentItem.idPallet) {
                            await this.generatePalletQr(this.currentItem.idPallet);
                        } else {
                            this.qrCodeData = "";
                        }

                        // Espera a que Vue renderice los cambios (por ejemplo, el QR si existe)
                        await this.$nextTick();

                        // Captura el contenido renderizado en imagen
                        if (this.contentToPrint) {
                            const canvas = await HTML2CANVAS(this.contentToPrint, {
                                backgroundColor: '#ffffff',
                                scale: 2,
                                useCORS: true
                            });

                            const imgData = canvas.toDataURL('image/png');
                            const imgWidth = 148;
                            const imgHeight = (canvas.height * imgWidth) / canvas.width;

                            doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
                        }
                    }

                    doc.save('labels.pdf');
                }

                this.overlay = false;
                this.showTemplate = false;
            } else {
                this.showMessageWarning("Please select a stock");
            }
        } else {
            this.showMessageWarning("SuperAdmin has not company settings.");
        }
    }

    async printStockNew(data: any) {
        // --- 0) Helper para columna Excel (A, B, C... P, etc.) ---
        const getExcelColumnName = (colNumber: number): string => {
            let temp = "";
            let number = colNumber;
            while (number > 0) {
                const remainder = (number - 1) % 26;
                temp = String.fromCharCode(65 + remainder) + temp;
                number = Math.floor((number - 1) / 26);
            }
            return temp;
        };

        // --- 1) Definimos las columnas EXACTAS en el orden deseado ---
        // 🔹 SIN "EAN CODE" ni "T1 DOCUMENT"
        const headers = [
            "DATE IN",
            "INBOUND CODE",
            "SUPPLIER",
            "GOOD",
            "GOOD CODE",
            "TYPE PALLET",
            "PALLET CODE",
            "LOCATION",
            "LANGUAGE",
            "TOTAL CASES",
            "QUANTITY CASE",
            "TOTAL PIECES",
            "BEST BEF. DATE",
            "WEIGHT"
        ];

        const rawRows = (data && data.rows) ? data.rows : [];

        // --- 2) Filtrar filas válidas ---
        const validRows = rawRows.filter((r: any) => {
            return r &&
                r["Pallet id"] &&
                r["Good"] &&
                r["Total cases"] !== undefined;
        });

        // --- 3) Construir datos para Excel (sin totales todavía) ---
        const excelData: any[] = validRows.map((r: any) => {
            return {
                "DATE IN": r["Date In"] || "",
                "INBOUND CODE": r["Dossier Number Source"] || "",
                "SUPPLIER": r["Company Source"] || "",
                "GOOD": r["Good"] || "",
                "GOOD CODE": r["Good Code"] || "",
                "TYPE PALLET": r["Pallet type"] || "",
                "PALLET CODE": r["Pallet id"] || "",
                "LOCATION": r["Location"] || "",
                "LANGUAGE": r["Language"] || "",
                "TOTAL CASES": Number(r["Total cases"] || 0),
                "QUANTITY CASE": Number(r["Goods per case"] || 0),
                "TOTAL PIECES": Number(r["Total cases"] || 0) * Number(r["Goods per case"] || 0),
                "BEST BEF. DATE": r["BestBeforeDate"] || "",
                "WEIGHT": Number(r["Weight"] || 0)
            };
        });

        // --- 4) Totales ---
        const totals: any = {
            "DATE IN": "",
            "INBOUND CODE": "",
            "SUPPLIER": "",
            "GOOD": "TOTALS:",
            "GOOD CODE": "",
            "TYPE PALLET": "",
            "PALLET CODE": excelData.length, // total pallets visibles
            "LOCATION": "",
            "LANGUAGE": "",
            "TOTAL CASES": excelData.reduce((s: number, r: any) => s + (r["TOTAL CASES"] || 0), 0),
            "QUANTITY CASE": "",
            "TOTAL PIECES": excelData.reduce((s: number, r: any) => s + (r["TOTAL PIECES"] || 0), 0),
            "BEST BEF. DATE": "",
            "WEIGHT": excelData.reduce((s: number, r: any) => s + (r["WEIGHT"] || 0), 0)
        };

        excelData.push(totals);

        // --- 5) LÓGICA ORIGINAL PARA EL NOMBRE DEL ARCHIVO ---
        //    Usamos solo las filas sin totales
        const palletIdsVisible = excelData
        .slice(0, -1)
        .map((row: any) => row["PALLET CODE"])
        .filter((p: any) => !!p);

        const filtered = this.StockList.filter((s: any) =>
            palletIdsVisible.includes(s.idPallet)
        );

        const uniq = (arr: any[]) =>
            Array.from(new Set(arr.filter((v: any) => !!v)));

        const visibleInbounds = uniq(filtered.map((s: any) => s.codeInbounds));
        const visibleCustomers = uniq(filtered.map((s: any) => s.customerName));

        const today = new Date();
        const dd = String(today.getDate()).padStart(2, "0");
        const mm = String(today.getMonth() + 1).padStart(2, "0");
        const yyyy = today.getFullYear();
        const formattedDate = dd + '-' + mm + '-' + yyyy;

        const sanitize = (t: string) =>
            t.replace(/\s+/g, "_").replace(/[^a-zA-Z0-9_]/g, "");

        let fileName = `${formattedDate}_WHSSTOCK.xlsx`;

        if (visibleInbounds.length === 1) {
            fileName = `${sanitize(visibleInbounds[0])}_${fileName}`;
        } else if (visibleCustomers.length === 1) {
            fileName = `${sanitize(visibleCustomers[0])}_${fileName}`;
        }

        // --- 6) Crear Excel con ExcelJS ---
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Stock");

        const lastColLetter = getExcelColumnName(headers.length);

        // Título
        sheet.mergeCells(`A1:${lastColLetter}1`);
        const titleCell = sheet.getCell("A1");
        titleCell.value = `Stock Report - ${formattedDate}`;
        titleCell.font = { size: 20, bold: true, color: { argb: "FFFFFFFF" } }; // 🔹 LETRA 20
        titleCell.alignment = { horizontal: "center", vertical: "middle" };
        titleCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF2F75B5" }
        };
        sheet.getRow(1).height = 58; // 🔹 ALTURA FILA TÍTULO

        // Fila de encabezado
        const headerRow = sheet.addRow(headers);
        headerRow.height = 58; // 🔹 ALTURA FILA CABECERA
        headerRow.eachCell((cell: any) => {
            cell.font = { bold: true, size: 20, color: { argb: "FFFFFFFF" } }; // 🔹 LETRA 20
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FF4472C4" }
            };
            cell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
        });

        // Filas de datos (incluye totales al final)
        excelData.forEach((rowObj: any) => {
            const rowValues = headers.map(h => rowObj[h]);
            const row = sheet.addRow(rowValues);

            row.height = 58; // 🔹 ALTURA TODAS LAS FILAS

            const isTotalsRow = rowObj["GOOD"] === "TOTALS:";

            row.eachCell((cell: any) => {
                cell.font = { size: 20, bold: isTotalsRow }; // 🔹 LETRA 20
                cell.alignment = { vertical: "middle" };
                cell.border = {
                    top: { style: "thin" },
                    left: { style: "thin" },
                    bottom: { style: "thin" },
                    right: { style: "thin" }
                };

                if (isTotalsRow) {
                    cell.fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: "FFE2EFDA" }
                    };
                }
            });
        });

        // Ajuste de ancho de columnas
        sheet.columns.forEach((col: any) => {
            let max = 12;
            col.eachCell({ includeEmpty: true }, (cell: any) => {
                const v = cell.value ? cell.value.toString().length : 0;
                if (v > max) max = v;
            });
            col.width = max + 2;
        });

        // Descargar
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), fileName); // ✅ Usa tu lógica de nombre
    }

    async printStockGrouped(
        formatToPrint: string,
        idWarehouses: string[],
        dateIn: string[],
        bestBeforeDate: string[],
        locationName: string[],
        customerName: string[],
        inboundCode: string[],
        inboundCodeDestination: string[],
        goodName: string[],
        companySourceName: string[]
    ) {
        if (this.warehouseIds.length > 0) {
            if (this.isSuperAdmin === false) {
                this.overlay = true;
                let settingsCompany = SettingsCompany.Settings.IdStockListGroupPrinting;
                let idRepport: ISettingsCompany[] =
                    await this.settingsCompanyApi.getSettingCompanyId(
                        this.idCompany,
                        settingsCompany
                    );

                if (idRepport) {
                    let idsWarehouses: string[] = [];
                    let dateIns: string[] = [];
                    let bestBeforeDates: string[] = [];
                    let locationNames: string[] = [];
                    let customerNames: string[] = [];
                    let inboundCodes: string[] = [];
                    let inboundCodeDestinations: string[] = [];
                    let companySourceNames: string[] = [];
                    let goodNames: string[] = [];

                    if (idWarehouses.length > 0) {
                        idWarehouses.forEach(i => idsWarehouses.push("'" + i + "'"));
                    } else {
                        this.warehouseIds.forEach(i => idsWarehouses.push("'" + i + "'"));
                    }
                    if (dateIn.length > 0) { dateIn.forEach(i => dateIns.push("'" + i + "'")); }
                    if (bestBeforeDate.length > 0) { bestBeforeDate.forEach(i => bestBeforeDates.push("'" + i + "'")); }
                    if (locationName.length > 0) { locationName.forEach(i => locationNames.push("'" + i + "'")); }
                    if (customerName.length > 0) { customerName.forEach(i => customerNames.push("'" + i + "'")); }
                    if (inboundCode.length > 0) { inboundCode.forEach(i => inboundCodes.push("'" + i + "'")); }
                    if (inboundCodeDestination.length > 0) { inboundCodeDestination.forEach(i => inboundCodeDestinations.push("'" + i + "'")); }
                    if (goodName.length > 0) { goodName.forEach(i => goodNames.push("'" + i + "'")); }
                    if (companySourceName.length > 0) { companySourceName.forEach(i => companySourceNames.push("'" + i + "'")); }

                    let printLabelUrl: string =
                    await this.printingApi.PrintStockGroupedWithFilters(
                        idRepport[0].value,
                        idsWarehouses,
                        dateIns,
                        bestBeforeDates,
                        locationNames,
                        customerNames,
                        inboundCodes,
                        inboundCodeDestinations,
                        goodNames,
                        companySourceNames,
                        formatToPrint
                    );

                    if (printLabelUrl) {
                    // === Helpers locales ===
                        const unquote = function (arr: string[]): string[] {
                            return arr.map(function (s) {
                                return (s || '').replace(/^'+|'+$/g, '').trim().toLowerCase();
                            });
                        };

                        const norm = function (v: any): string {
                            return (v === null || v === undefined
                                ? ''
                                : v.toString()
                            ).trim().toLowerCase();
                        };

                        const toYmd = function (d: any): string {
                            if (!d) return '';
                            const dd = d instanceof Date ? d : new Date(d);
                            if (isNaN(dd.getTime())) return '';
                            const y = dd.getFullYear();
                            const m = String(dd.getMonth() + 1).padStart(2, '0');
                            const day = String(dd.getDate()).padStart(2, '0');
                            return y + '-' + m + '-' + day;
                        };

                        const inFilter = function (val: any, arr: string[]): boolean {
                            return arr.length === 0 || arr.indexOf(norm(val)) !== -1;
                        };

                        const inDateFilter = function (val: any, arr: string[]): boolean {
                            return arr.length === 0 || arr.indexOf(toYmd(val)) !== -1;
                        };

                        // === Normaliza arrays de filtros ===
                        const fIdsWarehouses = unquote(idsWarehouses);
                        const fDateIns = unquote(dateIns);
                        const fBestBeforeDates = unquote(bestBeforeDates);
                        const fLocationNames = unquote(locationNames);
                        const fCustomerNames = unquote(customerNames);
                        const fInboundCodes = unquote(inboundCodes);
                        const fInboundCodeDests = unquote(inboundCodeDestinations);
                        const fGoodNames = unquote(goodNames);
                        const fCompanySourceNames = unquote(companySourceNames);

                        // === Filtra el StockList ===
                        const filtered = this.StockList.filter(function (s: any) {
                            return (
                                inFilter(s.idWarehouse, fIdsWarehouses) &&
                                inDateFilter(s.dateIn, fDateIns) &&
                                inDateFilter(s.bestBeforeDate, fBestBeforeDates) &&
                                inFilter(s.location, fLocationNames) &&
                                inFilter(s.customerName, fCustomerNames) &&
                                inFilter(s.codeInbounds, fInboundCodes) &&
                                inFilter(
                                    s.codeDestination || s.inboundCodeDestination,
                                    fInboundCodeDests
                                ) &&
                            inFilter(s.goodName, fGoodNames) &&
                            inFilter(s.companySourceName, fCompanySourceNames)
                            );
                        });

                        // === Extrae los valores únicos ===
                        const uniq = function (arr: any[]): any[] {
                            return Array.from(
                                new Set(
                                    arr.filter(function (x) {
                                        return !!x;
                                    })
                                )
                            );
                        };

                        const visibleInbounds = uniq(
                            filtered.map(function (s: any) {
                                return s.codeInbounds;
                            })
                        );
                        const visibleCustomers = uniq(
                            filtered.map(function (s: any) {
                                return s.customerName;
                            })
                        );

                        // === Fecha actual ===
                        const today = new Date();
                        const dd = String(today.getDate()).padStart(2, '0');
                        const mm = String(today.getMonth() + 1).padStart(2, '0');
                        const yyyy = today.getFullYear();
                        const formattedDate = dd + mm + yyyy;

                        const sanitize = function (t: string): string {
                            return t.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '');
                        };

                        // === Construye nombre ===
                        let fileName = '';
                        if (visibleInbounds.length === 1) {
                            fileName =
                            sanitize(visibleInbounds[0]) +
                            '_' +
                            formattedDate +
                            '_WHSSTOCKGROUPED.xlsx';
                        } else if (visibleCustomers.length === 1) {
                            fileName =
                            sanitize(visibleCustomers[0]) +
                            '_' +
                            formattedDate +
                                '_WHSSTOCKGROUPED.xlsx';
                        } else {
                            fileName = formattedDate + '_WHSSTOCKGROUPED.xlsx';
                        }

                        this.uploadServiceApi.DownloadDocuments(printLabelUrl, fileName);
                    }
                }

                this.overlay = false;
            } else {
                this.showMessageWarning('SuperAdmin has not company settings.');
            }
        } else {
            this.showMessageWarning('Please select a warehouse');
        }
    }

    async getWarehouseStockGroupByPallet(warehouseIds: string[]) {
        this.overlay = true;
        this.StockList = await this.stockApi.GetStockGroupByPallets(warehouseIds);
        
        const companyWarehouseIds = this.WarehouseList.filter(w => w.idCompany === this.idCompany).map(w => w.id);
        this.StockList = this.StockList.filter((i) =>
            i.idCompanyDestination === this.idCompany ||
            i.idCompanySource === this.idCompany ||
            companyWarehouseIds.includes(i.idWarehouse)
        );

        if (this.showCustomer === false) {
            this.StockList.forEach((i) => {
                let indexCustomer = this.CustomerList.findIndex(c => c.id === i.idCustomer);
                if (indexCustomer !== -1) {
                    if (i.idCompanyDestination !== this.CustomerList[indexCustomer].idCompany && this.idCompany !== i.idCompanySource) {
                        i.customerName = "";
                    }
                } else {
                    i.customerName = "";
                }
            });
        }
        this.overlay = false;
    }

    groupByPallet(warehouses: IWarehouse[], groupByActive: boolean) {
        if (warehouses.length > 0) {
            let ids = warehouses.map(w => w.id);
            this.StockList = [];
            if (groupByActive) {
                this.getWarehouseStockGroupByPallet(ids);
            } else {
                this.getWarehouseStock(ids);
            }
        } else {
            this.StockList = [];
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
